import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useShopifyCookies } from '@shopify/hydrogen-react';
import { CartProvider } from './context/CartContext';
import { sendPageView } from './lib/shopifyAnalytics';
import { HomePage } from './pages/HomePage';
import { ProductPage } from './pages/ProductPage';
import { BundlePage } from './pages/BundlePage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { SciencePage } from './pages/SciencePage';
import { ShippingPage } from './pages/ShippingPage';
import { FAQPage } from './pages/FAQPage';
import { SubscribePage } from './pages/SubscribePage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { BlogPage } from './pages/blog/BlogPage';
import { BlogDetailPage } from './pages/blog/BlogDetailPage';
import { ProductsPage } from './pages/ProductsPage';
import { LoadingScreen } from './components/LoadingScreen';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Reports page views to Shopify so headless-storefront visitors appear in Live View.
function ShopifyPageViewTracker() {
  const { pathname, search } = useLocation();
  useShopifyCookies({ hasUserConsent: true });
  useEffect(() => { sendPageView(); }, [pathname, search]);
  return null;
}

function App() {
  return (
    <CartProvider>
      <LoadingScreen />
      <Router>
        <ScrollToTop />
        <ShopifyPageViewTracker />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:productId" element={<ProductPage />} />
          <Route path="/bundle" element={<BundlePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/science" element={<SciencePage />} />
          <Route path="/shipping" element={<ShippingPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/subscribe" element={<SubscribePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;
